// This file includes various journey team names to be used in the
// ownershipTeam field passed in sentry error context objects

export const JOURNEY_EXPERIENCE_TEAM = 'journey-experience';
